export enum Database {
  Blob,
  Attachment,
  AttachmentToSave,
  AttachmentToRemove,
  AttachmentToUpdate,
}
